import { render } from "./embodiedRobots.vue?vue&type=template&id=02c52693&scoped=true"
import script from "./embodiedRobots.vue?vue&type=script&lang=js"
export * from "./embodiedRobots.vue?vue&type=script&lang=js"

import "./embodiedRobots.vue?vue&type=style&index=0&id=02c52693&lang=scss&scoped=true"

import exportComponent from "/home/jenkins-prod/worker1/workspace/jaka-digital/A-01-OTA/jaka-ota-admin-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02c52693"]])

export default __exports__